module.exports = __webpack_public_path__ + "static/img/img189.a5a926b8.png";